export default __webpack_public_path__ + "static/media/civilImage.ce52826b.png";